import { DataConsumption, DataManagement, DataIngestion } from "icons";

export const getClientApp = (subdomain, domain, fullDomain) => {

  return [
    {
      name: "Data Ingestion",
      icon: DataIngestion,
      description: "Data Ingestion App",
      url: {
        development: "http://banner.lvh.me:5173/ingestion",
        staging: `https://${subdomain}.${
          domain === "Jackson" ? "net" : domain
        }/ingestion`,
        production: `${fullDomain}/ingestion`
      },
      isActive: true,
    },
    {
      name: "Data Management",
      icon: DataManagement,
      description: "Data Management App",
      url: {
        development: "http://banner.lvh.me:5173/management",
        staging: `https://${subdomain}.${
          domain === "Jackson" ? "net" : domain
        }/management`,
        production: `${fullDomain}/management`
      },
      isActive: true,
    },
    {
      name: "Data Consumption",
      icon: DataConsumption,
      description: "Data Consumption App",
      url: {
        development: "http://banner.lvh.me:5173/consumption",
        staging: `https://${subdomain}.${
          domain === "Jackson" ? "net" : domain
        }/consumption`,
        production: `${fullDomain}/consumption`
      },
      isActive: true,
    },
  ];
};
